// src/pages/Law.tsx
import React from "react";
import Header from "components/Header";
import Footer from "components/Footer";

export default function Law() {
  const Wrap: React.CSSProperties = {
    maxWidth: 720,
    margin: "0 auto",
    padding: "16px 14px 40px",
    lineHeight: 1.9,
    color: "#0b1a27",
    background: "#fff",
  };
  const H1: React.CSSProperties = {
    fontSize: 22,
    fontWeight: 800,
    letterSpacing: "0.02em",
    margin: "22px 0 10px",
    color: "#1e73be",
  };
  const H2: React.CSSProperties = {
    fontSize: 16,
    fontWeight: 800,
    margin: "14px 0 6px",
  };
  const P: React.CSSProperties = { margin: "8px 0" };
  const DL: React.CSSProperties = { margin: "6px 0 14px" };
  const DT: React.CSSProperties = { fontWeight: 700, marginTop: 6 };
  const DD: React.CSSProperties = { margin: "2px 0 8px" };
  const Small: React.CSSProperties = { fontSize: 12, opacity: 0.85 };

  // 料金表：左UI風（行ごとに「100ポイント＝10000円」）
  const PriceNote: React.CSSProperties = { fontSize: 13, margin: "6px 0 10px" };
  const PriceList: React.CSSProperties = {
    border: "1px solid #e5e9f2",
    background: "#f9fbff",
    borderRadius: 8,
    padding: "10px 12px",
    lineHeight: 1.8,
  };
  const PriceRow: React.CSSProperties = {
    display: "flex",
    justifyContent: "space-between",
    gap: 12,
  };
  const PriceL: React.CSSProperties = { fontWeight: 700 };
  const PriceR: React.CSSProperties = { fontWeight: 700 };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        background: "#f5f7fb",
        overflowY: "auto",
      }}
    >
      <Header />

      <main style={{ flex: 1 }}>
        <div style={Wrap}>
          <h1 style={H1}>特定商取引法に基づく表記</h1>

          {/* 事業者情報 */}
          <section>
            <dl style={DL}>
              <dt style={DT}>販売事業者名</dt>
              <dd style={DD}>株式会社クリエイティブHOME</dd>

              <dt style={DT}>運営統括責任者</dt>
              <dd style={DD}>泉 淳也</dd>

              <dt style={DT}>所在地</dt>
              <dd style={DD}>福岡県福岡市早良区次郎丸2-10-2</dd>

              <dt style={DT}>電話番号</dt>
              <dd style={DD}>
                092-688-4599 <span style={Small}>※原則メールにてご連絡ください</span>
              </dd>

              <dt style={DT}>メールアドレス</dt>
              <dd style={DD}>support@boat-okuman.com</dd>

              <dt style={DT}>サイトURL</dt>
              <dd style={DD}>https://boat-okuman.com</dd>
            </dl>
          </section>

          {/* 価格表記・ポイント制 */}
          <section>
            <h2 style={H2}>商品代金（価格）</h2>
            <p style={P}>
              当サイトはポイント制（<b>1pt = 100円</b>）です。各商品（プラン）ページに必要ポイント数を税込で表示します。
              ポイントの<strong>有効期限は6ヶ月（180日）</strong>です。
            </p>
          </section>

          {/* 料金表（左UI風） */}
<section>
  <h2 style={H2}>料金表（ポイント購入）</h2>
  <p style={PriceNote}>情報料：1P = 100円</p>
  <div style={PriceList}>
    <div style={PriceRow}><span style={PriceL}>100pt＝10,000円</span></div>
    <div style={PriceRow}><span style={PriceL}>150pt＝14,500円</span></div>
    <div style={PriceRow}><span style={PriceL}>200pt＝19,000円</span></div>
    <div style={PriceRow}><span style={PriceL}>300pt＝28,000円</span></div>
    <div style={PriceRow}><span style={PriceL}>400pt＝37,000円</span></div>
    <div style={PriceRow}><span style={PriceL}>500pt＝46,000円</span></div>
    <div style={PriceRow}><span style={PriceL}>600pt＝54,000円</span></div>
    <div style={PriceRow}><span style={PriceL}>700pt＝64,000円</span></div>
    <div style={PriceRow}><span style={PriceL}>800pt＝73,000円</span></div>
    <div style={PriceRow}><span style={PriceL}>900pt＝82,000円</span></div>
    <div style={PriceRow}><span style={PriceL}>1000pt＝91,000円</span></div>
    <div style={PriceRow}><span style={PriceL}>2000pt＝181,000円</span></div>
    <div style={PriceRow}><span style={PriceL}>3000pt＝271,000円</span></div>
  </div>
  <p style={{ ...Small, marginTop: 8 }}>
    ※価格は変更となる場合があります。最新の表示をご確認ください。
  </p>
</section>


          {/* 商品代金以外の必要料金 */}
          <section>
            <h2 style={H2}>商品代金以外の必要料金</h2>
            <ul style={{ paddingLeft: 24, margin: "6px 0 12px" }}>
              <li>インターネット接続に関わる通信料</li>
              <li>振込手数料・決済事業者所定の手数料はお客様負担</li>
            </ul>
          </section>

          {/* お支払い方法 */}
          <section>
            <h2 style={H2}>お支払い方法</h2>
            <p style={P}>
              銀行振込決済／クレジットカード決済（いずれも前払い）。
              決済時の為替レート等の影響で請求額が異なる場合があります。
            </p>
          </section>

          {/* 提供時期 */}
          <section>
            <h2 style={H2}>商品（役務）の提供時期</h2>
            <p style={P}>
              該当レース開催日の当日に、メールおよびサイト内（マイページ等）で提供します。
              日時指定のあるプランは、各プラン記載の公開時刻以降に閲覧可能です。
            </p>
          </section>

          {/* 返品・返金 */}
          <section>
            <h2 style={H2}>返品（返金）・キャンセルについて</h2>
            <p style={P}>
              デジタルコンテンツでの情報サービスという商品の性質上、
              <b>購入後の返金・返品は一切お受けできません</b>。
              重複決済等の明確な事務誤りが確認できた場合は個別に対応いたします。
            </p>
          </section>

          {/* 退会 */}
          <section>
            <h2 style={H2}>退会方法</h2>
            <p style={P}>
              当サイト内の「お問い合わせ」より退会をご申請ください。
              確認後、順次手続きを行います。
            </p>
          </section>

          {/* 動作環境 */}
          <section>
            <h2 style={H2}>動作環境</h2>
            <p style={P}>
              最新版の主要ブラウザ（Chrome / Safari / Edge / Firefox）に対応。
              推奨環境以外での動作は保証いたしかねます。
            </p>
          </section>

          {/* 注意書き */}
          <section>
            <h2 style={H2}>表現および商品に関する注意</h2>
            <p style={P}>
              本サイトで提供する情報は利益を保証するものではありません。
              予想・分析・助言等は参考情報であり、最終的な投資判断はご自身の責任で行ってください。
            </p>
          </section>

          {/* 問い合わせ */}
          <section>
            <h2 style={H2}>お問い合わせ窓口</h2>
            <p style={P}>
              「お問い合わせ」ページのフォーム、または上記メールアドレス宛にご連絡ください。
              原則として10:00〜18:00に対応（年末年始・臨時休業を除く）。
            </p>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}
